import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { gsap } from 'gsap';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const logoUrl = '/logo.png';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsOpen(false);
    }
  };

  const navLinks = [
    { name: 'Home', id: 'hero' },
    { name: 'About Us', id: 'about' },
    { name: 'Our Stories', id: 'stories' },
    { name: 'Flavors', id: 'flavors' },
    { name: 'How to Order', id: 'how-to-order' },
    { name: 'FAQs', id: 'faqs' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo with Title */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src={logoUrl} 
              alt="Dough-nate Logo" 
              className="h-20 w-auto object-contain"
            />
            <div className="text-2xl font-bold">
              <span className="text-amber-600">Dough</span>
              <span className="text-pink-500">-</span>
              <span className="text-amber-600">nate</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            {navLinks.map((link, index) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="nav-link relative text-gray-700 hover:text-amber-600 font-medium transition-colors duration-300 py-2 pb-4"
              >
                {link.name}
                {/* Sprinkles under nav titles */}
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 flex space-x-1 opacity-0 nav-sprinkles transition-opacity duration-300">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-pink-500"></span>
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-teal-400"></span>
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-amber-400"></span>
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-pink-500"></span>
                </div>
              </button>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 hover:text-amber-600 transition-colors"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={28} /> : (
              <div className="flex flex-col space-y-1">
                <span className="w-2 h-2 rounded-full bg-pink-500"></span>
                <span className="w-2 h-2 rounded-full bg-teal-400"></span>
                <span className="w-2 h-2 rounded-full bg-amber-400"></span>
              </div>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t shadow-lg">
          <div className="px-4 py-4 space-y-4">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="flex items-center w-full text-left text-gray-700 hover:text-amber-600 font-medium transition-colors duration-300 py-2"
              >
                <span className="inline-block w-2 h-2 rounded-full bg-pink-500 mr-3"></span>
                {link.name}
              </button>
            ))}
          </div>
        </div>
      )}

      <style jsx>{`
        .nav-link:hover .nav-sprinkles {
          opacity: 1;
        }
      `}</style>
    </nav>
  );
};

export default Navigation;